<template>
    <div class="pages">
        <!-- <iframe :src="pdfUrl" class="pdfBox"></iframe> -->
        <div class="patew">
            <div class="title">
                关于园测信息科技股份有限公司拟首次公开发行股票接受辅导的公告
            </div>
            <pdf ref="pdf" v-for="i in numPages" :key="i" :src="pdfUrl" :page="i"></pdf>

        </div>
        <div>
            <CopyRight></CopyRight>
        </div>
    </div>
</template>
  
<script>

import vuePdf from "vue-pdf";
const pdf = { ...vuePdf, destroyed: undefined }

export default {
    components: {
        pdf
    },


    data() {
        return {
            pdfUrl: "",
            numPages: undefined,
            httpUrl: "",
            type: 1
        }
    },

    mounted() {
        let name = this.$route.query.name;
        var loadingTask = pdf.createLoadingTask(name);

        this.pdfUrl = loadingTask;

        console.log(name)
        this.pdfUrl.promise.then(pdf => {
            this.numPages = pdf.numPages;
            console.log(this.numPages, pdf.numPages)
        }).catch(err => {
            console.log('err', err)
        });



    },
    methods: {

    }
}
</script>
  
<style lang="scss" scoped>
.pages {
    margin-top: 60px;
  

    .patew {
        width: 70%;
        margin-left: 15%;
        position: relative;
    }

    .title {
        background-color: #fbffff;
        height: 100px;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        font-weight: 700;
        z-index: 9;
        position: absolute;
        width: 100%;
        top: 40px;
        color: #000;

    }

    .bannerImg {
        width: 100%;
        display: block;
    }

    .more {
        position: absolute;
        top: 10px;
        right: 10px;

        .gifmore {
            width: 100px;
        }
    }
}
</style>